import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingFeaturesForm } from '../../forms';
import { ListingLink } from '../../components';
import config from '../../config';

import css from './EditListingFeaturesPanel.css';

const FEATURES_NAME = 'keyFeatures';

const EditListingFeaturesPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    submitButtonId,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingFeaturesPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingFeaturesPanel.createListingTitle" />
  );

  const keyFeatures = publicData && publicData.keyFeatures;
  const transmissions = publicData && publicData.transmissions;
  const fuelType = publicData && publicData.fuelType;
  const drivenKm = publicData && publicData.drivenKm;
  const isPHV = publicData && publicData.isPHV;
  const peopleNumber = publicData && publicData.peopleNumberMax ? publicData.peopleNumberMax : '4';
  const initialValues = {
    keyFeatures,
    fuelType,
    drivenKm,
    isPHV,
    transmissions: transmissions ? transmissions[0] : null,
    peopleNumber,
  };

  return (
    <div className={classes}>
      {/* <h1 className={css.title}>{panelTitle}</h1> */}
      <div className={css.titleSection}>
        <h1 className={css.title}>{panelTitle}</h1>
        <p>
          Enter the features of your car. Most of the time these features are the deciding factor
          when renting the car.
        </p>
      </div>
      <EditListingFeaturesForm
        className={css.form}
        name={FEATURES_NAME}
        initialValues={initialValues}
        onSubmit={values => {
          const {
            transmissions = '',
            keyFeatures = [],
            fuelType = '',
            drivenKm = '',
            peopleNumber = '',
          } = values;

          const updatedValues = {
            publicData: {
              transmissions: [transmissions],
              keyFeatures,
              fuelType,
              drivenKm,
              peopleNumber: [1, parseInt(peopleNumber)],
            },
          };
          onSubmit(updatedValues);
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        fuelTypes={config.custom.typeOfFuel}
        transmissionType={config.custom.transmissions}
        drivenKm={config.custom.drivenKm}
        peopleNumber={initialValues.peopleNumber}
        submitButtonId={submitButtonId}
      />
    </div>
  );
};

EditListingFeaturesPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingFeaturesPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
  submitButtonId: string,
};

export default EditListingFeaturesPanel;
